module.exports = __webpack_public_path__ + "img/ClipZoo480px.f0e99b27.png";